// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_ju-1";
export var rowFirst = "_ju-3";
export var rowLast = "_ju-5";
export var rowMiddle = "_ju-4";
export var ticketListScroll = "_ju-2";
export var ticketStack = "_ju-0";